// extracted by mini-css-extract-plugin
export default {"noresults":"NoResult_noresults__VzbhI"};